<script>
import { computed } from 'vue'

export default {
  name: 'indicadorIA',
  props: {
    indicador: {
      type: Object,
      default: () => ({
        treinos_gerados_ia: 0,
        treinos_ia_mes_atual: 0,
        treinos_ia_ultimos_7_dias: 0,
        total_conversas_ia: 0,
        total_mensagens_ia: 0,
        total_tokens_usados: 0,
        custo_total_ia: '0.0000',
        top_treinadores_ia: [],
      }),
    },
    totalTreinos: { type: Number, default: 0 },
  },
  setup(props) {
    const percentualIA = computed(() => {
      if (props.totalTreinos === 0) return 0
      return (
        (props.indicador?.treinos_gerados_ia / props.totalTreinos) *
        100
      ).toFixed(1)
    })

    const formatNumber = (num) => {
      if (!num) return '0'
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    }

    return { percentualIA, formatNumber }
  },
}
</script>

<template>
  <div class="card kpi-card kpi-ciano text-white h-100">
    <div class="card-body">
      <div class="d-flex justify-content-between align-items-start mb-2">
        <div>
          <small class="opacity-75 text-uppercase fw-bold">Inteligência Artificial</small>
          <div class="kpi-valor">{{ indicador?.treinos_gerados_ia || 0 }}</div>
          <small class="opacity-90">treinos gerados com IA ({{ percentualIA }}%)</small>
        </div>
        <div class="kpi-icon-box">
          <i class="material-icons">smart_toy</i>
        </div>
      </div>

      <div class="ia-split mt-3">
        <div class="ia-item">
          <div class="fw-bold">{{ indicador?.treinos_ia_mes_atual || 0 }}</div>
          <small>Este mês</small>
        </div>
        <div class="ia-divider"></div>
        <div class="ia-item">
          <div class="fw-bold">{{ indicador?.treinos_ia_ultimos_7_dias || 0 }}</div>
          <small>7 dias</small>
        </div>
        <div class="ia-divider"></div>
        <div class="ia-item">
          <div class="fw-bold">{{ formatNumber(indicador?.total_tokens_usados) }}</div>
          <small>Tokens</small>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.kpi-card {
  border: none;
}
.kpi-ciano {
  background: linear-gradient(135deg, #0891b2 0%, #0e7490 100%);
  box-shadow: 0 4px 12px rgba(8, 145, 178, 0.3);
}

.kpi-valor {
  font-size: 2rem;
  font-weight: 700;
  line-height: 1.1;
  margin: 4px 0;
}

.kpi-icon-box {
  width: 42px;
  height: 42px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.2);
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.kpi-icon-box i { font-size: 22px; }

.ia-split {
  display: flex;
  align-items: center;
  gap: 8px;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 8px;
  padding: 8px 10px;
}
.ia-item {
  flex: 1;
  text-align: center;
  line-height: 1.1;
}
.ia-item small {
  opacity: 0.85;
  font-size: 0.7rem;
}
.ia-divider {
  width: 1px;
  height: 28px;
  background: rgba(255, 255, 255, 0.3);
}
</style>
